import React, { useState, useEffect } from 'react';
import '../App.css';
import { Link, useNavigate } from 'react-router-dom';
import * as Strings from './strings'
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import search from '../assets/search_white.png';
import user from '../assets/user.png';
import MyStorage from './util/storage'
import Api from './api/api'
import MyLoader from './util/loader'
import MyError from './util/error'
import showToast from './util/toast'
import { ToastContainer, toast } from 'react-toastify';

const Withdrawals = () => {
  const [models, setModels] = useState([]);
  const [loader, setLoader] = useState(false);

  // load data
  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true)
    Api.getWithdrawals(
      (models) => {
        setLoader(false)
        console.log('models: ' + models.length);
        setModels(models)
      },
      (error) => {
        setLoader(false)
        showToast('error', error)
      })
  };

  const markPaid = (model) => {
    Api.updateWithdrawalStatus(model.id, 'paid',
      () => {
        const list = models.map((item) => {
          if (item.id === model.id) {
            return { ...item, status: 'paid' };
          }
          else {
            return item;
          }
        });
        setModels(list)
      },
      (error) => {
        showToast('error', error)
      })
  };

  return (
    <div className='main'>
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
        <div style={{ color: 'blue' }}>
          Withdrawal Requests
        </div>
      </div>

      <div style={{ marginTop: 25 }}></div>

      {/* doctorId: doctor.id,
            doctorEmail: doctor.email,
            bankName: bankName,
            accountNo: accountNo,
            accountName: accountName,
            amount: amount,
            status: 'pending',
            date: moment().format('MM-DD-YYYY h:m a'),
            added_date: parseInt('' + moment()) */}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', overflow: 'scroll', }}>
        {models.map((model, index) => {
          return (
            <div style={{ display: 'flex', marginRight: 15, marginBottom: 15, backgroundColor: '#f2f2f2', padding: 10, borderRadius: 10, width: '45%' }}>
              <div style={{ marginTop: 0, display: 'flex' }}>
                <div style={{}}>
                  {/* <div style={{ fontSize: 16, fontWeight: 'bold', color: 'green' }}>#{index + 1}</div> */}
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Doctor ID:</div> {model.doctorId}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Email:</div> {model.doctorEmail}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Bank Name:</div> {model.bankName}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Account No:</div> {model.accountNo}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Account Name:</div> {model.accountName}</div>
                  <div style={{ fontSize: 16, display: 'flex' }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Amount:</div> ${model.amount}</div>
                  <div style={{ display: 'flex', fontSize: 16, marginBottom: 0 }}>
                    <div style={{ fontWeight: 'bold' }}>Status:</div>
                    <div style={{ marginLeft: 10, color: model.status === 'pending' ? 'blue' : model.status === 'paid' ? 'green' : 'blue' }}>{model.status}</div>
                  </div>
                  <div style={{ fontSize: 16, display: 'flex', marginBottom:10 }}><div style={{ fontSize: 16, fontWeight: 'bold', marginRight: 10 }}>Request Date:</div> {model.date}</div>

                  {model.status === 'pending' ?
                    <div style={{ display: 'flex' }}>
                      <Button
                        className='btn-block btn-submit'
                        style={{ width: 200, fontSize: 16, backgroundColor: 'green', color: 'white' }}
                        onClick={() => {
                          console.log('click');
                          markPaid(model)
                        }}>
                        Mark Paid
                      </Button>
                    </div>
                    :
                    null
                  }

                </div>

              </div>

            </div>
          );
        })}
      </div>

      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
}

export default Withdrawals;